package com.ijoin.data.model

import kotlinx.serialization.Serializable

@Serializable
data class SlotIdsRequest(
    val slotIds: List<Long>,
)
